import {Paddle} from "../../Paddle";
import axios from "axios";
import apiClient from "../../apiClient";
import dashboard from "../../pages/Dashboard";
import {getAuth} from "firebase/auth";

export const billing = {
    state() {
        return {
            subscription: null,
            receipts: [],
            products: [
                {
                    name: "Enterprise",
                    monthly: {
                        id: "16369",
                        amount: 8.99
                    },
                    yearly: {
                        id: "22426",
                        amount: 80.99
                    },
                },
                {
                    name: "Unlimited",
                    monthly: {
                        id: "16410",
                        amount: 24.99
                    },
                    yearly: {
                        id: "16411",
                        amount: 224.99
                    },
                },
            ],
            isLoading: false,
        };
    },
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setSubscription(state, subscription) {
            state.subscription = subscription;
        },
        setReceipt(state, receipts) {
            state.receipts = receipts;
        },
    },
    actions: {
        updatePaymentMethod({state, dispatch}) {
            return new Promise((resolve, reject) => {
                Paddle.getInstance().Checkout.open({
                    override: state.subscription.updateUrl,
                    successCallback: async () => {
                        await dispatch("fetchSubscription");
                        resolve();
                    },
                });
            });
        },
        async resumeSubscription(context) {
            context.commit("setIsLoading", true);
            await apiClient.post("/billing/subscription/resume")

            context.dispatch("fetchSubscription");
        },
        async pauseSubscription(context) {
            context.commit("setIsLoading", true);
            await apiClient.post("/billing/subscription/pause")

            context.dispatch("fetchSubscription");
        },
        async cancelSubscription({commit, dispatch}) {
            commit("setIsLoading", true);
            await apiClient.post("/billing/subscription/cancel")

            dispatch(
                "onSuccess",
                "Your subscription was canceled"
            );

            dispatch("fetchSubscription");
        },

        async fetchSubscription(context) {
            try {
                context.commit("setIsLoading", true);
                context.commit("setSubscription", null);


                let subscription = await apiClient.get("/billing/subscription")
                    .then(response => response.data)

                context.commit("setSubscription", subscription)
                context.commit("setIsLoading", false);
            } catch (e) {
                console.error("Failed to load subscriptions", {error: e})
            }
        },
        async fetchReceipts(context) {
            try {
                let receipts = await apiClient.get("/billing/receipts").then((response) => response.data);
                context.commit("setReceipt", receipts);
            } catch (e) {
                console.error("Failed to load receipts", {error: e})
            }
        },

        async resumeCanceledSubscription(context) {
            try {
                let url = await apiClient.post("/billing/subscription/undo-cancel").then(response => response.data.url)

                Paddle.getInstance().Checkout.open({
                    override: url,
                    successCallback: async () => {

                        context.commit("setIsLoading", true);
                        context.commit("setSubscription", null);

                        let refreshTimeout = 0
                        let subscription

                        let fn = async () => {
                            subscription = await apiClient.get("/billing/subscription")
                                .then(response => response.data).catch(() => null)

                            if (subscription && subscription.status !== "deleted") {
                                context.commit("setSubscription", subscription)
                                context.commit("setIsLoading", false);

                                context.dispatch(
                                    "onSuccess",
                                    "Your subscription was resumed successfully"
                                );
                            } else {
                                console.log(`Subscription not updated yet, waiting ${refreshTimeout} seconds`)
                                refreshTimeout += 1
                                setTimeout(fn, refreshTimeout * 1000)
                            }
                        }

                        fn()
                    },
                });
            } catch (e) {
                context.dispatch("onError", "Failed to resume subscription");
                console.error(e);
            }

        },

        async checkout(context, planId) {
            try {
                let timeout = 0
                const currentSubscriptionId = context.state.subscription.planId

                let url
                const successCallback = async () => {
                    context.state.isLoading = true

                    const newSubscription = await apiClient.get("/billing/subscription").then(response => response.data)

                    if (newSubscription.planId === currentSubscriptionId) {
                        timeout += 1
                        console.log(`Subscription not updated yet. Waiting ${timeout} seconds`)
                        return setTimeout(successCallback, timeout * 1000)
                    }

                    window.location.replace("/user_subscriptions?change_success=true");
                }

                url = await apiClient.post("/billing/checkout", {planId})
                    .then((response) => response.data.url);

                if (url) {
                    Paddle.getInstance().Checkout.open({
                        override: url,
                        successCallback
                    });
                } else {
                    successCallback()
                }
            } catch (e) {
                context.dispatch("onError", "An error occurred");
                console.error(e);
            }
        },
    },
};
